import type { FeedbackSentiment } from '@/types/feedbackConst';

/**
 * 감성(Sentiment) 비율 계산을 담당하는 클래스
 */
export class SentimentCalculator {
  /**
   * 특정 감성의 비율을 계산
   *
   * @param values - z축 값들 (감성별 값)
   * @param totalValue - 전체 값
   * @param sentiment - 계산할 감성 타입
   * @returns 감성 비율 (0-100)
   */
  static calculateSentimentPercentage(
    values: { value: number; z: StringNumberValue }[],
    totalValue: number,
    sentiment: FeedbackSentiment,
  ): number {
    if (!values || !Array.isArray(values)) return 0;

    const sentimentValue = values
      .filter((item) => item.z === sentiment)
      .reduce((sum, item) => sum + item.value, 0);

    return totalValue > 0 ? (sentimentValue / totalValue) * 100 : 0;
  }

  /**
   * 컬럼 전체의 감성 비율을 계산
   *
   * @param yHeader - y축 헤더 값
   * @param tableData - 테이블 데이터
   * @param sentiment - 계산할 감성 타입
   * @returns 컬럼 전체의 감성 비율 (0-100)
   */
  static calculateTotalSentimentPercentage(
    yHeader: StringNumberValue,
    tableData: ChartCrossTableData,
    sentiment: FeedbackSentiment,
  ): number {
    let totalSentimentValue = 0;
    let totalYValue = 0;

    tableData.forEach((xItem) => {
      const yItem = xItem.values.find((v) => v.y === yHeader);
      if (yItem && yItem.values) {
        totalYValue += yItem.value;
        const sentimentValue = yItem.values
          .filter((item) => item.z === sentiment)
          .reduce((sum, item) => sum + item.value, 0);
        totalSentimentValue += sentimentValue;
      }
    });

    return totalYValue > 0 ? (totalSentimentValue / totalYValue) * 100 : 0;
  }
}
